import React, { useState, useEffect, Fragment } from "react";
import PageTitle from "../../../Module/pageTitle";
import { useDispatch } from "react-redux";
import InputField from "../../../Component/inputField";
import Radiobtn from "../../../Component/radioBtn";
import LabelField from "../../../Component/labelField";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import AddMorebtn from "../../../Component/addMoreBtn";
import {
    getExamListNew,
    getParentCourseNew,
    uploadQuestionImage,
} from "../../../Action/courseAction";
import {
    showErrorSnackbar,
    showSuccessSnackbar,
} from "../../../Action/snackbarAction";
import {
    length_One,
    length_Three,
    validateIsFileImageType,
    image_size_150,
    containsMath,
} from "../../../Utils/validators";
import {
    validateIsFileImageTypeErrMsg,
} from "../../../Utils/errorMsg";
import ImagePickerAndViewer from "../../../Component/imagePickerAndViewer";
import OptionMCQ from "../../../Module/optionMCQ";
import CustomDropdown from "../../../Component/customDropdown";
import TextEditor from "../../DataEntryPanel/CreateQuestion/textEditor";
import DateTime from "../../../Component/dateTime";
import Dropdown from "../../../Component/dropdown";
import OptionMSQ from "../../../Module/optionMSQ";
import { addQuizOfTheDay, getQuizChannelList } from "../../../Action/actionFile";
import { getWordCountFromEditor } from "../../../Utils/utils";
function CreateQuizOfTheDay() {
    const dispatch = useDispatch();
    const [parentCourseVal, setparentCourseVal] = useState("");
    const [examName, setExamName] = useState("");
    const [topicName, setTopicName] = useState("");
    const [examList, setExamList] = useState([]);
    const [parentCourseList, setParentCourseList] = useState([]);
    const [resetParentCourse, setResetParentCourse] = useState(false);
    const [resetExam, setResetExam] = useState(false);
    const [chatID, setChatID] = useState("");
    const [resetChatID, setResetChatID] = useState(false);
    const [ChatList, setChatList] = useState([]);
    const [quizStartDate, setQuizStartDate] = useState("");
    const [duration, setDuration] = useState("");
    const [notificationDate, setNotificationDate] = useState("");
    const [partList, setPartList] = useState({ questionType: 1 });
    const initialValueForExam = {
        title: [],
        options: [],
        ansDescription: { text: "", img: "", video: "" },
        questionType: 1,
    };
    const [questionData, setQuestionData] = useState([initialValueForExam]);
    const ansTypeList = [
        { _id: 1, name: "MCQ" },
        { _id: 2, name: "MSQ" },
    ]
    useEffect(() => {
        dispatch(
            getExamListNew((res) => {
                setExamList(res);
            })
        );
        dispatch(
            getQuizChannelList((res) => {
                setChatList(res);
            })
        );

    }, []);

    useEffect(() => {
        if (!partList?.questionType) {
            setPartList((prev) => ({ ...prev, questionType: 1 }));
        }
    }, [partList]);
    const onListChange = (value) => {
        setExamName(value);
        setResetExam(false);
        setParentCourseList([]);
        setResetParentCourse(true);
        dispatch(
            getParentCourseNew(`${value._id}`, (res) => {
                setParentCourseList(res);
            })
        );
    };

    const changeParentCourseVal = (value) => {
        setparentCourseVal(value);
        setResetParentCourse(false);
    };
    const changeChatId = (value) => {
        setChatID(value);
        setResetChatID(false);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const updated = questionData?.map(q => ({
            ...q,
            options: q.options.map(({ index, ...rest }) => rest)
        }));
        const payload = {
            examTypeId: examName?._id,
            baseCourseId: parentCourseVal?._id,
            channelId: chatID?._id,
            startDate: quizStartDate,
            // notificationDate: notificationDate,
            duration: duration,
            topicName: topicName,
            questions: updated,
        };
        dispatch(
            addQuizOfTheDay(payload, () => {
                setExamName("");
                setResetExam(true);
                setChatID("");
                setResetChatID(true);
                setTopicName("");
                setparentCourseVal("");
                setDuration("");
                setResetParentCourse(true);
                setQuizStartDate("");
                setNotificationDate("");
                setQuestionData([
                    {
                        title: [],
                        options: [],
                        ansDescription: { text: "", img: "", video: "" },
                        questionType: 1,
                    },
                ]);
            })
        );
    };

    const showInputMenu = (type, qIndex) => {
        setQuestionData((prev) => {
            const updated = [...prev];
            const title = updated[qIndex]?.title ? [...updated[qIndex].title] : [];
            title.push({
                descType: type,
                description: "",
            });
            updated[qIndex] = { ...updated[qIndex], title };
            return updated;
        });
    };

    const onChangeTitleImg = (e, qIndex, tIndex) => {
        e.preventDefault();
        if (!validateIsFileImageType(e)) {
            dispatch(showErrorSnackbar(validateIsFileImageTypeErrMsg));
            return;
        }

        if (e.target.files[0].size > image_size_150) {
            dispatch(showErrorSnackbar("File size should be less than 150 KB!!!"));
        } else {
            const file = e.target.files[0];
            dispatch(
                uploadQuestionImage(
                    file,
                    (res) => {
                        if (res?.media) {
                            dispatch(showSuccessSnackbar("File Successfully Uploaded"));
                            handleChangeTitleText(qIndex, tIndex, res.media);
                        } else {
                            dispatch(showErrorSnackbar("File Not Uploaded"));
                        }
                    },
                    () => { }
                )
            );
        }
    };
    const handleChangeTitleText = (qIndex, tIndex, value) => {
        let MaxCount = 300
        let wordCount = 0
        if (value && containsMath(value || "")) {
            // Allow larger word count for math content
        }
        else {
            wordCount = getWordCountFromEditor(value);

            if (wordCount > MaxCount) {
                dispatch(showErrorSnackbar(`Title description should be less than ${MaxCount} words.`));
                return;
            }
        }
        setQuestionData((prev) => {
            const updated = [...prev];
            if (!updated[qIndex]?.title) return prev;
            const title = [...updated[qIndex].title];
            title[tIndex] = {
                ...title[tIndex],
                description: value,
            };
            updated[qIndex] = {
                ...updated[qIndex],
                title,
            };

            return updated;
        });
    };
    const validations = () => {
        const validateQuestions = () => {
            return questionData?.map((question, index) => {
                const errors = [];
                if (!question.title || question.title.length === 0) { errors.push("Title is missing"); } else { question.title.forEach((t, i) => { if (!t.description || t.description.trim() === "") { errors.push(`Title description is empty at index ${i}`); } }); }
                // 2. Options validation
                if (!question.options || question.options.length === 0) { errors.push("Options are missing"); } else {
                    question.options.forEach((opt, i) => { if (!opt.descType || opt.descType.trim() === "") { errors.push(`Option descType is empty at index ${i}`); } if (!opt.description || opt.description.trim() === "") { errors.push(`Option description is empty at index ${i}`); } });
                    // 3. isCorrect validation 
                    const hasCorrectAnswer = question.options.some((opt) => opt.isCorrect === true); if (!hasCorrectAnswer) { errors.push("At least one option must be marked as correct"); }
                }
                return { questionIndex: index, isValid: errors.length === 0, errors, };
            });
        };
        const invalidQuestions = validateQuestions().filter(q => !q.isValid);
        return (
            parentCourseVal === "" || examName === "" || topicName === "" || chatID === "" || quizStartDate === "" || duration === "" || invalidQuestions.length > 0
        );
    };
    console.log("questionData", questionData);
    const renderTitle = (qIndex) => {
        const question = questionData[qIndex];
        const MaxCount = 300;
        const handleRemoveTitleItem = (index) => {
            const newData = [...questionData];
            newData[qIndex].title.splice(index, 1);
            setQuestionData(newData);
        };
        return (
            <div className="container mt-20">
                <div className="CreateQuestionTitle d-flex justify-content-between">
                    <h5 className="admitCardHeading text-left d-flex ">Part A</h5>
                    {question?.title?.length === 0 ? (
                        <div className=" d-flex">
                            <div
                                className="cursor addInputbtn ms-2 p-1"
                                onClick={() => showInputMenu("text", qIndex)}
                            >
                                + Text
                            </div>
                            <div
                                className="cursor addInputbtn ms-2 p-1"
                                onClick={() => showInputMenu("img", qIndex)}
                            >
                                + Image
                            </div>
                        </div>
                    ) : null}
                </div>

                {question?.title?.map((item, index) => {
                    const { description } = item;
                    return (
                        <div className="position-relative col-12" key={index}>
                            <span className="position-absolute justify-content-end p-2 removeButton">
                                <HighlightOffIcon
                                    className="cursor"
                                    color="primary"
                                    fontSize="small"
                                    onClick={() => handleRemoveTitleItem(qIndex, index)}
                                />
                            </span>
                            {item?.descType === "text" ? (
                                <div className="editor_content mt-2 mb-2">
                                    <TextEditor
                                        setInputText={(value) =>
                                            handleChangeTitleText(qIndex, index, value)
                                        }
                                        value={description}
                                        isSetWordCount={containsMath(description || "") ? false : true}
                                        maxLength={MaxCount}
                                    />
                                    {description && containsMath(description || "") ? null : <div><b>Remaining Characters Count:</b> {MaxCount - (getWordCountFromEditor(description) || 0)}</div>}
                                </div>
                            ) : (
                                <div className="mt-2 mb-2">
                                    <ImagePickerAndViewer
                                        labelName={""}
                                        value={description}
                                        handleChange={(e) => onChangeTitleImg(e, qIndex, index)}
                                        htmlFor={`desc-photo-upload +${qIndex}+ ${index}`}
                                        removelabel={true}
                                    />
                                </div>
                            )}
                        </div>
                    );
                })}
                {question?.title?.length > 0 ? (
                    <div className="d-flex justify-content-end">
                        <span
                            className="btn btn-outline-primary mb-3 me-2 addMorebtn"
                            onClick={() => showInputMenu("text", qIndex)}
                        >
                            + Text
                        </span>
                        {/* <span
                                    className="btn btn-outline-primary mb-3 addMorebtn"
                                    onClick={() => showInputMenu("img", qIndex)}
                                >
                                    + Image
                                </span> */}
                    </div>
                ) : null}
            </div>
        );
    };
    const renderMCQOptions = (qIndex) => {
        const question = questionData[qIndex];
        const options = question?.options || [];
        let MaxCount = 100
        let wordCount = 0
        const handleCloseOption = (optionIndex) => {
            setQuestionData((prev) => {
                const updated = [...prev];
                const updatedOptions = [...(updated[qIndex].options || [])];
                updatedOptions.splice(optionIndex, 1);
                updated[qIndex].options = updatedOptions;
                return updated;
            });
        };

        const onChangeOption = (optionIndex, data) => {
            console.log("data", data);
            wordCount = getWordCountFromEditor(data?.description);

            if (wordCount > MaxCount) {
                dispatch(showErrorSnackbar(`Option description should be less than ${MaxCount} words.`));
                return;
            }
            setQuestionData((prev) => {
                const updated = [...prev];
                const updatedOptions = [...(updated[qIndex].options || [])];
                if (data.isCorrect) {
                    updatedOptions.forEach((opt, i) => {
                        if (opt) opt.isCorrect = i === optionIndex;
                    });
                }
                updatedOptions[optionIndex] = { ...data, isCorrect: data.isCorrect };
                updated[qIndex].options = updatedOptions;
                return updated;
            });
        };
        const onchangeMSQ = (optionIndex, data) => {
            setQuestionData((prev) => {
                const updated = [...prev];
                const updatedOptions = [...(updated[qIndex].options || [])];
                updatedOptions[optionIndex] = { ...data, isCorrect: data.isCorrect };
                updated[qIndex].options = updatedOptions;
                return updated;
            });
        }

        return questionData[qIndex]?.options.map((item, index) => (
            <div className="position-relative col-auto" key={index}>
                <span className="position-absolute justify-content-end p-2 removeButton">
                    {options.length > 1 && (
                        <HighlightOffIcon
                            className="cursor"
                            color="primary"
                            fontSize="small"
                            onClick={() => handleCloseOption(index)}
                        />
                    )}
                </span>
                {question?.questionType === 1 ? (
                    <OptionMCQ
                        key={index}
                        index={index}
                        setOptionData={(data) => onChangeOption(index, data)}
                        option={item}
                        labelName={`correct${qIndex}`}
                        noImage
                        maxLength={MaxCount}
                        isSetWordCount={true}
                    />) : question?.questionType === 2 ? (
                        <OptionMSQ
                            key={index}
                            index={index}
                            setOptionData={(data) => onchangeMSQ(index, data)}
                            option={item}
                            noImage
                            maxLength={MaxCount}
                            isSetWordCount={true}
                        />) : null}

                <div><b>Remaining Characters Count:</b> {MaxCount - (getWordCountFromEditor(item?.description) || 0)}</div>
            </div>
        ));
    };

    const renderDescription = (qIndex) => {
        const desc = questionData[qIndex]?.ansDescription || {
            text: "",
            img: "",
            video: "",
        };
        const ensureAnsDescription = (prev) => {
            if (!prev[qIndex].ansDescription) {
                prev[qIndex].ansDescription = { text: "", img: "", video: "" };
            }
        };

        const updateQuestionData = (callback) => {
            setQuestionData((prev) => {
                const updated = structuredClone(prev);
                ensureAnsDescription(updated);
                callback(updated[qIndex].ansDescription);
                return [...updated];
            });
        };

        const handleRemove = (type) => {
            updateQuestionData((descObj) => {
                descObj[type] = "";
            });
        };

        const handleChangeText = (value) => {
            updateQuestionData((descObj) => {
                descObj.text = value;
            });
        };

        const handleChangeFile = (type, file) => {
            if (!file) return;
            if (
                type === "img" &&
                !validateIsFileImageType({ target: { files: [file] } })
            ) {
                dispatch(showErrorSnackbar(validateIsFileImageTypeErrMsg));
                return;
            }

            updateQuestionData((descObj) => {
                descObj[type] = URL.createObjectURL(file);
            });

            dispatch(
                uploadQuestionImage(
                    file,
                    (res) => {
                        if (res?.media) {
                            dispatch(showSuccessSnackbar("File Successfully Uploaded"));
                            updateQuestionData((descObj) => {
                                descObj[type] = res.media;
                            });
                        } else {
                            dispatch(showErrorSnackbar("File Not Uploaded"));
                        }
                    },
                    () => {
                        dispatch(showErrorSnackbar("Upload Failed"));
                    }
                )
            );
        };

        const showDesc = (type) => {
            updateQuestionData((descObj) => {
                if (type === "text") descObj.text = "";
                else if (type === "img") descObj.img = "";
                else if (type === "video") descObj.video = "";
            });

            if (type === "img" || type === "video") {
                setTimeout(() => {
                    document
                        .getElementById(
                            type === "img"
                                ? `desc-photo-upload-${qIndex}`
                                : `desc-video-upload-${qIndex}`
                        )
                        ?.click();
                }, 100);
            }
        };

        return (
            <div className="mt-20">
                <div className="CreateQuestionTitle d-flex justify-content-between">
                    <h5 className="admitCardHeading text-left">Answer description</h5>

                    <div className="d-flex">
                        {!desc.text && (
                            <div
                                className="cursor addInputbtn ms-2 p-1"
                                onClick={() => showDesc("text")}
                            >
                                + Text
                            </div>
                        )}
                        {/* {!desc.img && (
                                    <div
                                        className="cursor addInputbtn ms-2 p-1"
                                        onClick={() => showDesc("img")}
                                    >
                                        + Image
                                    </div>
                                )}
                                {!desc.video && (
                                    <div
                                        className="cursor addInputbtn ms-2 p-1"
                                        onClick={() => showDesc("video")}
                                    >
                                        + Video
                                    </div>
                                )} */}
                    </div>
                </div>

                {/* {desc.text && ( */}
                    <div className="position-relative mb-2">
                        <span className="position-absolute top-0 end-0 p-2 removeButton">
                            <HighlightOffIcon
                                className="cursor"
                                onClick={() => handleRemove("text")}
                            />
                        </span>
                        <TextEditor value={desc.text} setInputText={handleChangeText} isSetWordCount={true}
                            maxLength={100}
                        />
                        {desc.text && containsMath(desc.text || "") ? null : <div><b>Remaining Characters Count:</b> {100 - (getWordCountFromEditor(desc.text) || 0)}</div>}
                    </div>
             {/* )} */}


            </div>
        );
    };

    const onPressQuestionAdd = () => {
        setQuestionData([...questionData, initialValueForExam]);
    };
    const handleCloseQuestionData = (index) => {
        const newArray = [...questionData];
        if (index > -1) {
            newArray.splice(index, 1);
        }
        setQuestionData(newArray);
    };
    const onPressAddOption = (qIndex) => {
        setQuestionData((prev) => {
            const updated = [...prev];
            const options = updated[qIndex].options || [];

            if (options.length < 4) {
                options.push({ descType: " ", description: "", isCorrect: false });
                updated[qIndex].options = options;
            }
            return updated;
        });
    };

    const onChangeAnsType = (value, qIndex) => {
        setQuestionData((prev) => {
            const updated = [...prev];
            updated[qIndex].questionType = value?._id;
            return updated;
        });
    };
    console.log("questionData", questionData);
    const renderQuestion = () => {
        return (
            <div>
                {questionData?.map((item, index) => {
                    const { questionType } = item;
                    const FilterAnsType = ansTypeList.find((type) => type._id === questionType);

                    const validateQuestion = (question) => {
                        const errors = [];
                        // 1. Title validation
                        if (!question.title || question.title.length === 0) {
                            errors.push("Title is missing");
                        } else {
                            question.title.forEach((t, i) => {
                                if (!t.description || t.description.trim() === "") {
                                    errors.push(`Title description is empty at index ${i}`);
                                }
                            });
                        }

                        // 2. Options validation
                        if (!question.options || question.options.length === 0) {
                            errors.push("Options are missing");
                        } else {
                            question.options.forEach((opt, i) => {
                                if (!opt.descType || opt.descType.trim() === "") {
                                    errors.push(`Option descType is empty at option ${i + 1}`);
                                }
                                if (!opt.description || opt.description.trim() === "") {
                                    errors.push(`Option description is empty at option ${i + 1}`);
                                }
                            });

                            // 3. isCorrect validation
                            const hasCorrectAnswer = question.options.some(
                                (opt) => opt.isCorrect === true
                            );

                            if (!hasCorrectAnswer) {
                                errors.push("At least one option must be marked as correct");
                            }
                        }

                        return {
                            isValid: errors.length === 0,
                            errors,
                        };
                    };

                    const validationResult = validateQuestion(item);

                    return (
                        <div key={index} className=" position-relative">
                            <span className="d-flex justify-content-end p-2  ">
                                {questionData.length === 1 ? null : (
                                    <HighlightOffIcon
                                        className="cursor"
                                        color="primary"
                                        fontSize="small"
                                        onClick={() => handleCloseQuestionData(index)}
                                    />
                                )}
                            </span>

                            <div className="sectioncontainer col-md-10 p-4">
                                <div className=" d-flex w-100 row">
                                    <div className="col-auto  px-4 justify-content-between col-8">
                                        <div className="examdropdown justify-content-between">
                                            <div className="question-label">
                                                Question : {index + 1}
                                            </div>
                                        </div>
                                        <div className="d-flex mb-2 align-items-center">
                                            <LabelField labelName={"Answer Type"} />
                                            <div className="w-100">
                                                <Dropdown
                                                    setInputText={(value) => onChangeAnsType(value, index)}
                                                    value={FilterAnsType}
                                                    options={ansTypeList}
                                                    labelName="Select Answer Type"
                                                    Isrequired={true}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-auto  px-4 justify-content-between">
                                    <div className="d-flex"></div>
                                </div>

                                {renderTitle(index)}

                                <div className="container mb-5">{renderMCQOptions(index)}</div>

                                {partList?.questionType !== 3 &&
                                    (item.options?.length || 0) < 4 && (
                                        <div className="d-flex justify-content-end">
                                            <button
                                                type="button"
                                                className="NewOpt mb-4"
                                                onClick={() => onPressAddOption(index)}
                                            >
                                                + Add New Option
                                            </button>
                                        </div>
                                    )}

                                {renderDescription(index)}
                                {validationResult && !validationResult?.isValid && <div className="text-danger mt-3 fw-bold">{validationResult?.errors?.join(", ")}</div>}
                            </div>

                        </div>
                    );
                })}

                <div className="col-auto d-flex justify-content-end mt-4">
                    <AddMorebtn handleClick={onPressQuestionAdd} />
                </div>
            </div>
        );
    };

    return (
        <div className="contentBox">
            <PageTitle name={"CREATE QUIZ OF THE DAY"} />
            <div className="row m-0 p-3">
                <div className=" formDiv  w-100 ">
                    <form className="col-md-12" onSubmit={handleSubmit}>
                        <div className="col-md-6">
                            <div className="d-flex mb-2 align-items-center">
                                <LabelField labelName={"Exam Name"} isRequired={true} />
                                <CustomDropdown
                                    setInputText={(value) => onListChange(value)}
                                    value={examName}
                                    options={examList}
                                    labelName="Select Exam Name"
                                    reset={resetExam}
                                // Isrequired={true}
                                />
                            </div>
                            <div className="d-flex mb-2 align-items-center">
                                <LabelField labelName={"Exam Stream"} isRequired={true} />
                                <CustomDropdown
                                    setInputText={(value) => changeParentCourseVal(value)}
                                    value={parentCourseVal}
                                    options={parentCourseList}
                                    labelName="Select Exam Stream"
                                    reset={resetParentCourse}
                                // Isrequired={true}
                                />
                            </div>
                            <div className="d-flex mb-2 align-items-center">
                                <LabelField labelName={"Chat ID"} isRequired={true} />
                                <CustomDropdown
                                    setInputText={(value) => changeChatId(value)}
                                    value={chatID}
                                    options={ChatList}
                                    labelName="Select Chat ID"
                                    reset={resetChatID}
                                // Isrequired={true}
                                />
                            </div>
                            <div className="d-flex align-items-center w-100">
                                <LabelField labelName={"Quiz Start Date & Time"} isRequired={true} />
                                <DateTime
                                    setInputText={(value) => {
                                        setQuizStartDate(value);
                                    }}
                                    value={quizStartDate}
                                />
                            </div>
                            {/* <div className="d-flex align-items-center w-100">
                                <LabelField labelName={"Notification Date & Time"} isRequired={true} />
                                <DateTime
                                    setInputText={(value) => {
                                        setNotificationDate(value);
                                    }}
                                    value={notificationDate}
                                />
                            </div> */}
                            <div className="d-flex align-items-center w-100">
                                <InputField
                                    labelName={"Quiz Duration (In Minutes)"}
                                    placeholder={"Enter Duration"}
                                    setInputText={(value) =>
                                        setDuration(value)
                                    }
                                    value={duration}
                                    maxLength={length_Three}
                                    minLength={length_One}
                                    Isrequired={true}
                                />

                            </div>
                            <div className="d-flex align-items-center w-100">
                                <InputField
                                    labelName={"Topic Name"}
                                    placeholder={"Enter Topic Name"}
                                    setInputText={(value) =>
                                        setTopicName(value)
                                    }
                                    value={topicName}
                                    // maxLength={length_Fifty}
                                    minLength={length_One}
                                    Isrequired={true}
                                />

                            </div>
                        </div>
                        {renderQuestion()}
                        <div className="col-auto d-flex justify-content-center mt-4">
                            <button
                                type="submit"
                                className={`btn mb-3 submitbtn ${validations() ? "btn-secondary" : "btn-primary"
                                    }`}
                                // className={"btn mb-3 submitbtn btn-primary"}
                                disabled={validations()}
                            >
                                Create Quiz
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default CreateQuizOfTheDay;
